import { client } from "../../client";

/**
 * Handles the list of all used and vacant characters.
 * @param {Array} args list of all characters represented as a 0 for free or a -1 for taken
 */
export const handleCharsCheck = (args: string[]) => {
  for (let i = 0; i < client.char_list_length; i++) {
    const img = document.getElementById(`demo_${i}`);
    const entry = document.getElementById(`charlist_${i}`);
    const taken = args[i + 1] === "-1";
    // Class-driven so the grid and the AO2-style list dim consistently
    // (a darkened/greyed icon, like AO2) rather than a near-invisible fade.
    if (img) img.classList.toggle("taken", taken);
    if (entry) entry.classList.toggle("taken", taken);
  }
};
